import { useEffect } from "react";
import { useState } from "react";
import { SIZE_OPTION_GROUP_ID } from "../../utils/Constant";

function ProductOptionsMobile({
  productOptions,
  onOptionSelectedCb,
  mobileSelect2Ref,
  setsizeGuideoptionmobilefunction,
}) {
  const [sizeOptions, setSizeOptions] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [disableSize, setDisableSize] = useState(false);

  useEffect(() => {
    let sizeOptionsObj =
      productOptions?.find((e) => e.id === SIZE_OPTION_GROUP_ID) || {};
    setSizeOptions(sizeOptionsObj);
    if (sizeOptionsObj?.items && sizeOptionsObj?.items?.length === 1) {
      setDisableSize(true);
      setSelectedSize(sizeOptionsObj?.items[0]);
    }
  }, [productOptions]);

  // const handleSizeOptionClick = () => {
  //   if (sizeOptions) {
  //     window.$("#size_prod").selectScroll({
  //       data: [
  //         sizeOptions?.items?.map((i) => {
  //           return { ...i, id: i.id, text: i.value };
  //         }) || [],
  //       ],
  //       title: sizeOptions?.title || "Pick an option",
  //       cancelTxt: "Cancel",
  //       cancelClass: "",
  //       confirmTxt: "Confirm",
  //       confirmClass: "",
  //       cancel: null, // callback
  //       confirm: (data) => {
  //         setSelectedSize(data[0] || {});
  //         console.log(data);
  //       },
  //     });
  //   }
  // };

  const handleMobileSelectClick = () => {
    let wheelsData =
      sizeOptions?.items?.map((i) => {
        if (i?.available_for_order === "1") {
          return { ...i, id: i.id, text: i.value };
        } else {
          /**
         * BOC 
         * @TicketId: Task#136939 - Changes in Size Guide
         * @author: Mohammad Meraj
         * @date: 28-Feb-2023
         * @use: Add this code to remove the soldout stripe from the size dropdown menu
         */
          if (i.value.indexOf("Sold Out") === -1) {
            i.value = i.value.strike();
          }
          return { ...i, id: i.id, text: i.value, disabled: true };
        }
      }) || [];
    if (sizeOptions) {
      if (mobileSelect2Ref.current) {
        mobileSelect2Ref.current.updateWheel(0, wheelsData);
      } else {
        let cancelBtnText = `<button class="btn-blank close-btn-newsletter">
          <img
            src=${
              process.env.PUBLIC_URL + "/assets/images/icons/Cross-Button.png"
            }
            className="close-btn-input close-btn-newsletter"
            alt=""
          />
        </button>`;
        mobileSelect2Ref.current = new window.MobileSelect({
          trigger: "#size_prod",
          title: sizeOptions?.title
            ? `Select ${sizeOptions?.title}`
            : "Pick an option",
          ensureBtnText: "Confirm",
          cancelBtnText: cancelBtnText,
          hideCancelBtn: false,
          hideEnsureBtn: true,
          className: "mobileSelect-show",
          position: [1],
          wheels: [
            {
              data: wheelsData,
            },
          ],
          callback: function (indexArr, data) {
            setSelectedSize(data[0] || {});
            const size = data[0] || {};
            setSelectedSize(size);            
            onOptionSelectedCb(sizeOptions?.id, size?.id, size?.value, size?.special_price, size?.discount_percentage);
          },
          transitionEnd: function (indexArr, data) {
            const size = data[0] || {};
            if (size?.available_for_order === "1") {
              mobileSelect2Ref.current.position = indexArr[0];
              setSelectedSize(size);              
              onOptionSelectedCb(sizeOptions?.id, size?.id, size?.value,size?.special_price, size?.discount_percentage, false);
            } else {
              // mobileSelect2.current.position = [0, indexArr[0] + 1]
              // setSelectedSize(size);              
              onOptionSelectedCb(sizeOptions?.id, size?.id, size?.value,size?.special_price, size?.discount_percentage, true);
            }
          },
          onShow: function () {
            const size = mobileSelect2Ref.current.position? sizeOptions?.items[mobileSelect2Ref.current.position] || {}: sizeOptions?.items[1] || {};
            if (size?.available_for_order === "1") {
              setSelectedSize(size);              
              onOptionSelectedCb(sizeOptions?.id, size?.id, size?.value,size?.special_price, size?.discount_percentage, false);
            }  
            setsizeGuideoptionmobilefunction("block");
          },
          onHide: function () {
            setsizeGuideoptionmobilefunction("none");
          },
        });

        mobileSelect2Ref.current.show();
      }
    }
  };

  if (!productOptions || productOptions.length < 1) return null;

  return (
    <>
      {sizeOptions && (
        <>
          <div className="d-mbl">
            <div
              className="test"
              id="size_prod"
              onClick={(e) => {
                e.preventDefault();
                if (!disableSize) {
                  handleMobileSelectClick();
                }
              }}
              style={{ cursor: "pointer" }}
              disabled={disableSize}
            >
              {selectedSize?.value
                ? `Size: ${selectedSize?.value}`
                : `Select ${sizeOptions?.title}`}
            </div>
            {/* <Dropdown className="addr">
                <Dropdown.Toggle variant="" id="dropdown-basic">
                  {selectedSize?.value || sizeOptions?.title}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {sizeOptions?.items?.map((option, idx) => {
                    return (
                      <Dropdown.Item
                        onClick={(e) => {
                          setSelectedSize(option);
                          onOptionSelectedCb(
                            sizeOptions?.id,
                            option?.id,
                            option?.value
                          );
                        }}
                        disabled={option?.available_for_order === "0"}
                        key={`ddl-option-${idx}`}
                      >
                        {option.value}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown> */}
          </div>
        </>
      )}
    </>
  );
}

export default ProductOptionsMobile;
